module.exports = __webpack_public_path__ + "static/media/eye-slashed.a994feaf.svg";